import React from "react";
import {
  Button,
  TextField,
  Autocomplete,
} from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  filters: { display: "flex", alignItems: "center", gap: 8 },
  filterItem: { flex: 1, minWidth: 0 },
  input: { "& .MuiOutlinedInput-root": { height: 44 } },
  btnAction: { flexShrink: 0, height: 44, fontSize: 14, fontWeight: 500, textTransform: "none", whiteSpace: "nowrap" },
}));

const Filter = ({ filter, onChange, onReset, onApply }) => {
  const classes = useStyles();

  const handleChange = (key, value) => {
    onChange(key, value);
  };

  return (
    <div className={classes.filters}>
      <div className={classes.filterItem}>
        <TextField
          value={filter.location}
          onChange={(e) => handleChange("location", e.target.value)}
          label="Местоположение"
          variant="outlined"
          fullWidth
          className={`${classes.input} --floating-label`}
        />
      </div>
      <div className={classes.filterItem}>
        <Autocomplete
          value={filter.complex_cam ? (filter.complex_cam === "sensor" ? { title: "Комплекс", value: "sensor" } : { title: "Камера", value: "camera" }) : null}
          options={[
            { title: "Комплекс", value: "sensor" },
            { title: "Камера", value: "camera" }
          ]}
          getOptionLabel={(option) => option.title}
          isOptionEqualToValue={(option, value) => option.value === value?.value}
          fullWidth
          renderInput={(params) => <TextField {...params} label="Комплекс/Камера" className={`${classes.input} --floating-label`} />}
          onChange={(e, v) => handleChange("complex_cam", v?.value || "")}
        />
      </div>
      <div className={classes.filterItem}>
        <Autocomplete
          multiple
          value={filter.class || []}
          options={["Стационарный", "Мобильный", "Передвижной"]}
          fullWidth
          renderInput={(params) => <TextField {...params} label="Тип комплекса" className={`${classes.input} --floating-label`} />}
          onChange={(e, v) => handleChange("class", v || [])}
        />
      </div>
      <div className={classes.filterItem}>
        <TextField
          value={filter.complex_serial}
          onChange={(e) => handleChange("complex_serial", e.target.value)}
          label="Серийный номер"
          variant="outlined"
          fullWidth
          className={`${classes.input} --floating-label`}
        />
      </div>
      <Button color="secondary" variant="contained" onClick={onReset} className={classes.btnAction}>
        Сбросить
      </Button>
      <Button variant="contained" onClick={onApply} className={classes.btnAction}>
        Применить
      </Button>
    </div>
  );
};

export default Filter;
